<template>
	<div>
		<!-- fetching upgrade requests -->
		<div v-if="!gotData">
			<sau-loading>
				<template slot="message">Fetching Upgrade Requests</template>
			</sau-loading>
		</div>

		<!-- Pending Upgrade -->
		<div v-else-if="pendingUpgrade && gotData">
			<sau-apiro-response type="message">
				<template slot="message">An upgrade request is currently pending for this service.</template>
			</sau-apiro-response>
		</div>
		<div v-else>
			<sau-apiro-response type="message">
				<template slot="message">We've detected this as one of our legacy products.</template>
				<template slot="details">
					<p>To access great new features such as Remote Management and Network Monitoring, you'll need to upgrade.</p>
					<b-link v-b-modal.upgrade-service class="sau-link-button sm">Contact Sales Now!</b-link>
					<sau-upgrade-modal v-on:updateFlag="updateUpgradeFlag"></sau-upgrade-modal>
				</template>
			</sau-apiro-response>
		</div>
	</div>
</template>

<script>
import UpgradeServiceModal from "./_UpgradeModal";
export default {
	components: {
		"sau-upgrade-modal": UpgradeServiceModal
	},
	data() {
		return {
			pendingUpgrade: false
		};
	},
	created() {
		this.startApp();
	},
	methods: {
		startApp() {
			this.checkPendingUpgrade().then(response => {
				if (response.data.status == "success") {
					this.pendingUpgrade = response.data.pendingUpgrade;
				}
			});
		},
		updateUpgradeFlag() {
			this.pendingUpgrade = true;
		}
	}
};
</script>

<style>
</style>
